import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export * from './data';
export * from './numbers';
export * from './text';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
